import { parseDateOnlyString } from '@gettactic/api';

export function dateParseISO(date: string) {
  return parseDateOnlyString(date);
}
